import { H2, Base } from '@sbab-ui/components'

export default function TopSection() {
  // Styling is added to this component to deliberately imitate Sitevisions design system
  return (
    <div className="flex flex-col gap-4">
      <H2
        className="max-w-[620px] !text-4xl sm:!text-[40px] sm:!leading-[50px]"
        style={{ color: '#101010' }}
      >
        Gör verklighet av planerna - Höj ditt bolån med Kilowattlånet
      </H2>
      <Base className="!mt-0 max-w-[620px]" style={{ color: '#101010' }}>
        Finansiera energirenoveringen med hjälp av Kilowattlånet. Din ränta på bolån sätts alltid
        utifrån hur mycket du vill låna i förhållande till värdet på din bostad. Räkna på räntan och
        se vad räntekostnaden för Kilowattlånet landar på.
      </Base>
    </div>
  )
}
